const loadingIndicatorReducerV2 = (reducer, actionName) => (state, action) => {
  const {type} = action;
  const matches = new RegExp("(FETCH|SAVE|DELETE)\\.(.*)\\.(REQUEST|SUCCESS|FAILURE)").exec(type);
  if (!matches) {
    return reducer(state, action);
  }

  const [,, requestName, requestState] = matches;
  const applyLoadingIndicator = (Array.isArray(actionName) && actionName.includes(requestName)) || actionName === requestName;
  if (!applyLoadingIndicator) {
    return reducer(state, action);
  }
  return reducer({...state, loading: requestState === 'REQUEST'}, action);
}


export default loadingIndicatorReducerV2;
